import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as actions from '../actions'

class App extends Component {
  constructor (props) {
    super(props)
    setInterval(() => {
      this.props.updateJWT()
    }, 540000)
  }
  render () {
    const { children } = this.props
    return (
      <div className="hwEsdpApp">
        {children}
      </div>
    )
  }
}

App.propTypes = {
  children: PropTypes.node,
  updateJWT: PropTypes.func
}

function mapStateToProps (state, ownProps) {
  return {
    serviceInfo: state.serviceInfo
  }
}

export default connect(mapStateToProps, {
  ...actions
})(App)



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/containers/App.js